<template>
  <div class="rightTable">
    <div class="rightSearch">
      <el-input ref="keyword" v-model="keyword" placeholder="请输入图纸名称和图纸编号" size="small">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="Table">
      <el-table ref="multipleTable" height="100%" highlight-current-row border :data="tableData" tooltip-effect="dark" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange" @row-click="rowClick">
        <el-table-column fixed type="selection" align="center" />
        <el-table-column fixed label="序号" type="index" width="60" />
        <el-table-column fixed label="图册号" width="120" align="center" show-overflow-tooltip prop="listName">
          <template slot-scope="scope">
            <span v-if="scope.row.drawingId==editId&&isNew">{{ folderData.folderName }}</span>
            <span v-else>{{ scope.row.listName }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed label="文件名称" width="150" align="center" show-overflow-tooltip :render-header="renderHeader">
          <template slot-scope="scope">
            <div v-if="scope.row.drawingId==editId&&scope.row.fileNameShow" class="box">
              <el-input
                :ref="'fileNameShow' + scope.row.drawingId" v-model.trim="scope.row.fileName" size="small" maxlength="50"
                @keydown.native="keydown($event)" @blur="loseFcous(scope.$index, scope.row)">
              </el-input>
            </div>
            <span v-else class="writtenWords">{{ scope.row.fileName }}
              <i class="el-icon-edit" @click="edit(scope.row,'fileNameShow')"></i></span>
          </template>
        </el-table-column>
        <el-table-column label="图框模板" width="150" align="center" show-overflow-tooltip :render-header="renderHeader">
          <template slot-scope="scope">
            <div v-if="scope.row.drawingId==editId&&scope.row.framNameShow" class="box">
              <el-select
                :ref="'framNameShow' + scope.row.drawingId" v-model="scope.row.framName" size="small"
                placeholder="请选择" filterable @change="changeFram(scope.row,scope.row.framName)"
                @visible-change="visibleChange">
                <el-option v-for="item in framList" :key="item.borderId" :label="item.borderName" :value="item.borderName">
                </el-option>
              </el-select>
            </div>
            <span v-else class="writtenWords">{{ scope.row.framName }}
              <i class="el-icon-edit" @click="edit(scope.row,'framNameShow')"></i></span>
          </template>
        </el-table-column>
        <el-table-column label="图纸等级" width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.drawingId==editId&&scope.row.drawingLevelNameShow" class="box">
              <el-select
                :ref="'drawingLevelNameShow' + scope.row.drawingId" v-model="scope.row.drawingLevelName" size="small" clearable
                placeholder="请选择" filterable @change="changeDrawingLevel(scope.row,scope.row.drawingLevelName)"
                @visible-change="visibleChange">
                <el-option v-for="item in drawingLevelList" :key="item.id" :label="item.cnName" :value="item.cnName">
                </el-option>
              </el-select>
            </div>
            <span v-else class="writtenWords">{{ scope.row.drawingLevelName }}
              <i class="el-icon-edit" @click="edit(scope.row,'drawingLevelNameShow')"></i></span>
          </template>
        </el-table-column>
        <el-table-column label="加长值" width="120" align="center" show-overflow-tooltip :render-header="renderHeader">
          <template slot-scope="scope">
            <div v-if="scope.row.drawingId==editId&&scope.row.lengthValueShow" class="box">
              <el-select :ref="'lengthValueShow' + scope.row.drawingId" v-model="scope.row.lengthValue" size="small"
                style="width:80px" placeholder="请选择" filterable @visible-change="visibleChange">
                <el-option v-for="(item,index) in lengthValueList" :key="index" :label="item.enName"
                  :value="item.enName">
                </el-option>
              </el-select>
            </div>
            <span v-else class="writtenWords">{{ scope.row.lengthValue }}
              <i class="el-icon-edit" @click="edit(scope.row,'lengthValueShow')"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,index) in columnList" :key="index" :label="item.colCnName" width="150" align="center">
          <template slot-scope="scope">
            <div v-for="(item1,index1) in scope.row.dynamicFieldList" :key="index1">
              <div v-if="item.fieldId===item1.fieldId">
                <div v-if="scope.row.drawingId==editId&&scope.row[item1.fieldId+'Show']&&item.typeId==='1'" class="box">
                  <el-input :id="[item1.fieldId+'Show'] + scope.row.drawingId" v-model.trim="item1.fieldValue" size="small"
                    maxlength="50" @keydown.native="keydown($event)" @blur="loseFcous(scope.$index, scope.row)">
                  </el-input>
                </div>
                <div v-else-if="scope.row.drawingId==editId&&scope.row[item1.fieldId+'Show']&&item.typeId==='2'" class="box">
                  <el-select :id="[item1.fieldId+'Show'] + scope.row.drawingId" v-model="item1.fieldValue" size="small"
                    placeholder="请选择" filterable multiple @change="changePeople(item1)" @visible-change="visibleChange">
                    <el-option v-for="(peopleItem,peopleIndex) in peopleList"
                      :key="peopleIndex"
                      :label="item.name"
                      :value="peopleItem.name">
                    </el-option>
                  </el-select>
                </div>
                <div v-else-if="scope.row.drawingId==editId&&scope.row[item1.fieldId+'Show']&&item.typeId==='3'" class="box">
                  <el-cascader
                    :id="[item1.fieldId+'Show'] + scope.row.drawingId"
                    v-model="item1.fieldValue"
                    :show-all-levels="false"
                    size="small"
                    :options="stampList"
                    :props="stampDefaultProps"
                    clearable
                    @change="changesSamp(item1)"
                    @visible-change="visibleChange"
                  ></el-cascader>
                </div>
                <span v-else class="writtenWords">
                  <span v-if="item.typeId==='3'">{{ fName(item1.fieldValue) }}</span>
                  <span v-else>{{ item1.fieldValue }}</span>
                  <i class="el-icon-edit" @click="edit(scope.row,[item1.fieldId+'Show'],item1)"></i>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="最近修改人" width="180" align="center" show-overflow-tooltip prop="operUserName" />
        <el-table-column label="最近修改时间" width="150" align="center" show-overflow-tooltip prop="operDate" />
      </el-table>
    </div>
    <div class="foot">
      <el-button v-if="establishShow" v-preventReClick type="primary" size="small" @click="establish">创建</el-button>
      <el-button v-if="establishShow" type="primary" size="small" plain @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import sheetSetService from "@/CommonDP/service/sheetSet-service";
import createProject from "@/CommonDP/service/createProject-service";
import personPlanService from "@/CommonDP/service/personPlan-service";
import requestprj from "@/CommonDP/service/standardPlan-service";
import stamp from "@/CommonDP/service/eSeal-service";

export default {
  data() {
    return {
      tableData: [], // 表数据
      keyword: "", // 搜索关键字
      rowIndex: 1,
      editId: "", // 判断编辑的是哪一行
      editData: [], // 编辑行初始数据
      emptyAddData: {
        enterpriseId: "",
        drawingId: "",
        prjId: "",
        listId: "",
        listName: '',
        framId: "",
        framName: "",
        framNameShow: true,
        fileName: "",
        fileNameShow: true,
        drawingLevelId: "",
        drawingLevelName: "",
        drawingLevelNameShow: true,
        dynamicFieldList: [],
        dataOrder: "",
        lengthValue: "",
        lengthValueShow: true
      },
      addData: {
        enterpriseId: "",
        drawingId: "",
        prjId: "",
        listId: "",
        listName: '',
        framId: "",
        framNameShow: true,
        framName: "",
        fileName: "",
        fileNameShow: true,
        drawingLevelId: "",
        drawingLevelName: "",
        drawingLevelNameShow: true,
        dynamicFieldList: [],
        dataOrder: "",
        lengthValue: "",
        lengthValueShow: true
      },
      framList: [],
      drawingLevelList: [],
      establishShow: false,
      rowData: {},
      selectionData: [],
      flagArr: [
        "framNameShow",
        "fileNameShow",
        "drawingLevelNameShow",
        "lengthValueShow"
      ],
      flag: true, // 用来控制 当前修改的字段 是否已完成修改 有的字段不能为空时 是不能关闭输入框的
      flag2: true, // 只有等修改完了一个  才能去修改另一个 用来控制频繁点击修改按钮
      columnList: [],
      peopleList: [],
      lengthValueList: [],
      stampList: [],
      stampDefaultProps: {
        children: "treeList",
        label: "sortName",
        value: "sortName",
        checkStrictly: true
      }
    };
  },
  computed: {
    ...mapState({
      folderData: (state) => state.sheetSet.folderData,
      isMajor: (state) => state.sheetSet.isMajor,
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    isNew() {
      // 是新建的图纸集就返回true  其他的就返回false
      if (this.folderData.childList === null) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    folderData() {
      this.rowInd = 0;
      this.queryList();
    },
    keyword() {
      this.queryList();
    },
    selectionData() {
      this.$store.dispatch("setSelectionData", this.selectionData);
    },
    rowData() {
      this.$store.dispatch("setrowData", this.rowData);
    }
  },
  mounted() {
    this.queryPrjDict();
  },
  methods: {
    fName(val) {
      const v = val ? val.split(",")[val.split(",").length - 1] : '';
      return v;
    },
    renderHeader(h, { column }) {
      return [h("span", { style: "color:#F56C6C;margin-right:3px" }, "*"), h("span", "" + column.label)];
    },
    async exportExcel() {
      const params = {
        keyWord: this.keyword,
        listId: this.folderData.folderId
      };
      const res = await sheetSetService.setPlanEditExportExcel(params);
      const fileName = "图纸集列表.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    keydown(e) {
      if (e.keyCode === 32) {
        e.returnValue = false;
      }
    },
    async queryList() {
      const params = {
        keyWord: this.keyword,
        listId: this.folderData.folderId
      };
      const listRes = await sheetSetService.prjDrawingSetPlanEditList(params);
      this.tableData = listRes.data;
      this.$emit('sendTableData', this.tableData);
      this.$nextTick(() => {
        this.rowIndex = 1;
        this.rowData = this.tableData[0];
        this.$refs.multipleTable.setCurrentRow(this.tableData[0]);
        this.$refs.multipleTable.doLayout();
      });
    },
    async queryPrjDict() {
      // 项目详情 图框模板
      this.columnList = [];
      const framRes = await requestprj.getStandardFiles(this.prjInfo.prjId, this.enterpriseId);
      this.framList = framRes.data;
      const lengthValueRes = await createProject.dicList("Extended");
      this.lengthValueList = lengthValueRes.data;
      const drawingLevelueRes = await createProject.dicList("DrawingLevel");
      this.drawingLevelList = drawingLevelueRes.data;
      const columnRes = await sheetSetService.getFrameColumnList(this.enterpriseId);
      let array = columnRes.data || [];
      this.columnList = this.unique(array, 'colId');
      this.columnList.forEach((item, index, arr) => {
        this.$set(item, 'fieldId', item.colId);
        this.$set(item, 'fieldName', item.colCnName);
        this.$set(item, 'fieldValue', '');
        this.$set(item, 'fieldValueId', '');
        const prop = item.colId + 'Show';
        this.$set(this.emptyAddData, prop, true);
        this.$set(this.addData, prop, true);
        this.flagArr.push(prop);
      });
      this.addData.dynamicFieldList = this.columnList;
      this.emptyAddData.dynamicFieldList = this.columnList;
      const stampRes = await stamp.getElectronic(this.enterpriseId);
      this.stampList = this.getTreeData(stampRes.data) || [];
    },
    getTreeData(data) {
      for (var i = 0;i < data.length > 0;i++) {
        if (data[i].treeList == null || data[i].treeList.length <= 0) {
          data[i].treeList = undefined;
        } else {
          this.getTreeData(data[i].treeList);
        }
      }
      return data;
    },
    // 去重
    unique(arr, key) {
      const res = new Map();
      return arr.filter((a) => !res.has(a[key]) && res.set(a[key], 1));
    },
    // 人员
    async queryUserDict() {
      if (this.isMajor.specId) {
        const params = {
          specId: this.isMajor.specId,
          prjId: this.prjInfo.prjId,
          enterpriseId: this.enterpriseId
        };
        const res = await personPlanService.queryPersonList(params);
        this.peopleList = res.data;
      }
    },
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 点击某一行
    rowClick(row) {
      this.rowData = row;
      this.rowIndex = row.index + 1;
    },
    // 快速添加
    addTable() {
      if (this.editId !== "") {
        this.$message({
          message: "请先创建",
          type: "warning"
        });
        return;
      }
      if (
        this.tableData.some((item) => {
          return item.drawingId === "";
        })
      ) {
        this.$message({
          message: "请先创建",
          type: "warning"
        });
        return;
      }
      this.addData = JSON.parse(JSON.stringify(this.emptyAddData));
      this.establishShow = true;
      if (this.tableData.length) {
        this.addData.dataOrder = this.rowIndex + 1;
      } else {
        this.addData.dataOrder = 1;
      }
      this.tableData.splice(this.rowIndex, 0, this.addData);
    },
    // 创建按钮
    async establish() {
      try {
        const data = this.getAddData();
        if (data) {
          await sheetSetService.prjDrawingSetPlanEditAdd(data);
          this.establishShow = false;
          this.$message.success("添加成功");
          this.queryList();
        }
      } catch (error) {
        this.addData.dynamicFieldList.forEach((item) => {
          if (item.typeId === "2" || item.typeId === "3") {
            item.fieldValue = item.fieldValue ? item.fieldValue.split(",") : [];
          }
        });
        console.log(error);
      }
    },
    // 取消创建
    cancelClick() {
      this.establishShow = false;
      this.tableData.forEach((item, index) => {
        if (item.drawingId === "") {
          this.tableData.splice(index, 1);
        }
      });
    },
    // 整理添加数据
    getAddData() {
      if (!this.addData.framName) {
        this.$message({
          message: "图框模板不能为空",
          type: "warning"
        });
        return;
      }
      if (!this.addData.fileName) {
        this.$message({
          message: "文件名称不能为空",
          type: "warning"
        });
        return;
      }
      const regExp = new RegExp("[\\\\|/:*<>?\"]");
      if (regExp.test(this.addData.fileName)) {
        this.$message.warning('文件名称不能包含以下字符:\\ / : * " ? < > |');
        return;
      }
      if (!this.addData.lengthValue) {
        this.$message({
          message: "加长值不能为空",
          type: "warning"
        });
        return;
      }
      this.addData.enterpriseId = this.enterpriseId;
      this.addData.listId = this.folderData.folderId;
      this.addData.listName = this.folderData.folderName;
      this.addData.prjId = this.prjInfo.prjId;
      this.addData.dynamicFieldList.forEach((item) => {
        if (item.typeId === "2" || item.typeId === "3") {
          item.fieldValue = item.fieldValue.toString();
        }
      });
      return this.addData;
    },
    // 复制添加
    async copyAddTable() {
      if (!this.rowData || JSON.stringify(this.rowData) === "{}" || this.rowData.drawingId === "") {
        this.$message({
          message: "请先选择数据",
          type: "warning"
        });
        return;
      }
      if (this.editId !== "") {
        this.$message({
          message: "请先创建",
          type: "warning"
        });
        return;
      }
      if (
        this.tableData.some((item) => {
          return item.drawingId === "";
        })
      ) {
        this.$message({
          message: "请先创建",
          type: "warning"
        });
        return;
      }
      this.flagArr.forEach((item) => {
        this.rowData[item] = true;
      });
      this.addData = JSON.parse(JSON.stringify(this.rowData));
      this.addData.dynamicFieldList.forEach((ele) => {
        if (ele.typeId === "2" || ele.typeId === "3") {
          ele.fieldValue = ele.fieldValue ? ele.fieldValue.split(",") : [];
        }
      });
      const dwg = this.addData.fileName.slice(-4);
      if (dwg === '.dwg') { this.addData.fileName = this.addData.fileName.slice(0, -4); }
      this.addData.drawingId = "";

      if (this.tableData.length) {
        this.addData.dataOrder = this.rowIndex + 1;
      } else {
        this.addData.dataOrder = 1;
      }
      this.establishShow = true;
      this.tableData.splice(this.rowIndex, 0, this.addData);
    },
    handleSelectionChange(val) {
      val.forEach((item, index, arr) => {
        item.dynamicFieldList.forEach((item1, index, arr) => {
          if (item1.fieldId === 'init200000000007') {
            this.$set(item, "drawingName", item1.fieldValue);
          }
        });
      });
      this.selectionData = val;
    },
    changeFram(row, val) {
      if (val) {
        if (this.editId) {
          this.rowData.framId = this.framList.find((ele) => ele.borderName === val).borderId;
        } else {
          this.addData.framId = this.framList.find((ele) => ele.borderName === val).borderId;
        }
      } else {
        this.addData.framId = "";
      }
    },
    changeDrawingLevel(row, val) {
      if (val) {
        if (this.editId) {
          this.rowData.drawingLevelId = this.drawingLevelList.find((ele) => ele.cnName === val).id;
        } else {
          this.addData.drawingLevelId = this.drawingLevelList.find((ele) => ele.cnName === val).id;
        }
      } else {
        if (this.editId) {
          this.rowData.drawingLevelId = "";
        } else {
          this.addData.drawingLevelId = "";
        }
      }
    },
    // 修改---输入框数据时
    async loseFcous(index, row) {
      if (row.drawingId) {
        try {
          this.flag2 = false;
          this.flag = true;
          if (!row.fileName && row.fileNameShow) {
            this.flag = false;
            this.$message({
              message: "文件名称不能为空",
              type: "warning"
            });
            return;
          }
          const regExp = new RegExp("[\\\\|/:*<>?\"]");
          if (regExp.test(row.fileName) && row.fileNameShow) {
            this.$message.warning('文件名称不能包含以下字符:\\ / : * " ? < > |');
            return;
          }
          const params = [row];
          await sheetSetService.prjDrawingSetPlanEditBatchUpdate(params);
          this.$message.success("修改成功");
          this.editId = "";
          await this.queryList();
          this.flag2 = true;
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 修改--下拉数据时
    async visibleChange(val) {
      if (this.editId !== "") {
        if (!val) {
          try {
            this.flag = true;
            if (!this.rowData.framName && this.rowData.framNameShow) {
              this.flag = false;
              this.$message({
                message: "图框模板不能为空",
                type: "warning"
              });
              return;
            }
            if (!this.rowData.lengthValue && this.rowData.lengthValueShow) {
              this.flag = false;
              this.$message({
                message: "加长值不能为空",
                type: "warning"
              });
              return;
            }
            this.rowData.dynamicFieldList.forEach((item) => {
              if (item.typeId === "2" || item.typeId === "3") {
                item.fieldValue = item.fieldValue.toString();
              }
            });
            const params = [this.rowData];
            await sheetSetService.prjDrawingSetPlanEditBatchUpdate(params);
            this.$message.success("修改成功");
            this.editId = "";
            this.queryList();
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
    async edit(row, flag, rowList) {
      if (this.flag2) {
        if (this.tableData.some((item) => { return item.drawingId === ""; })) {
          this.$message({
            message: "请先创建",
            type: "warning"
          });
          return;
        }
        if (this.flag === false) {
          return;
        }
        await this.flagFun(row);
        this.editId = "";
        const dwg = row.fileName.slice(-4);
        if (flag === 'fileNameShow' && dwg === '.dwg') {
          row.fileName = row.fileName.slice(0, -4);
        }
        this.editId = row.drawingId;
        this.rowData = row;
        if (rowList && (rowList.typeId === "2" || rowList.typeId === "3")) { rowList.fieldValue = rowList.fieldValue ? rowList.fieldValue.split(",") : []; }
        row[flag] = true;
        this.$nextTick(() => {
          const ref = flag + row.drawingId;
          if (rowList) {
            document.getElementById(ref).focus();
          } else {
            this.$refs[ref].focus();
          }
        });
      }
    },
    flagFun(datas) {
      this.flagArr.forEach((item, index, arr) => {
        datas[item] = false;
      });
    },
    changePeople(val) {
      val.fieldValueId = this.getNameList(val.fieldValue, this.peopleList);
    },
    getNameList(names, list) {
      const ids = [];
      names.forEach((ele) => {
        list.forEach((res) => {
          if (ele === res.name) {
            ids.push(res.userId);
          }
        });
      });
      return ids.toString();
    },
    async changesSamp(val) {
      const newval = val.fieldValue[val.fieldValue.length - 1];
      await this.getStampNameList(val, newval, this.stampList);
    },

    getStampNameList(val, str, list) {
      console.log(val, list);
      list.forEach((ele) => {
        if (ele.sortName === str) {
          val.fieldValueId = ele.sortID;
          return;
        } else {
          if (ele.treeList) {
            this.getStampNameList(val, str, ele.treeList);
          }
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.rightTable {
  height: 100%;
  .rightSearch {
    width: 100%;
    padding: 12px 0;
    text-align: right;
    .el-input {
      width: 250px;
    }
  }
  .Table {
    width: 100%;
    padding-left: 10px;
    flex-grow: 2;
    height: 100%;
    max-height: calc(100% - 120px);
    /deep/ .el-table__fixed{
      height: calc(100% - 10px) !important;
    }
    .el-date-editor.el-input {
      width: 139px;
    }
    /deep/ .el-tag.el-tag--info:first-of-type {
      .el-select__tags-text {
        width: 40px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
      }
    }
    .box {
      span {
        color: red;
        position: absolute;
        left: 10px;
        font-size: 15px;
      }
      .el-input {
        width: 143px;
      }
      .el-select {
        width: 143px;
      }
    }
    .writtenWords {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      min-width: 50px;
      display: inline-block;
      vertical-align: top;
      position: relative;
      padding-right: 15px;
      height: 25px;
      // line-height: 25px;
      i {
        display: none;
        position: absolute;
        top: 5px;
        right: 0px;
      }
    }
    .writtenWords:hover {
      i {
        display: inline-block;
      }
    }
    /* 菜单滚动条 */
    // /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    //   height: 10px;
    // }
    // /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    //   border-radius: 7px;
    // }
    // /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    //   border-radius: 7px;
    // }
  }
  .foot {
    padding: 10px 10px;
  }
}
</style>
